import SurveyDetails from "../../../components/surveys/SurveyDetails.vue";
import SurveyForm from "../../../components/surveys/SurveyForm.vue";
import SurveyGroupForm from "../../../components/surveys/SurveyGroupForm.vue";


export default [
    {
        path: '',
        name: 'survey.view',
        component: SurveyDetails
    },
    {
        path: 'edit',
        name: 'survey.edit',
        component: SurveyForm,
        props: { mode: 'edit' }
    },
    {
        path: 'group/add',
        name: 'survey.group.add',
        component: SurveyGroupForm,
    },
    {
        path: 'group/edit/:groupId',
        name: 'survey.group.edit',
        component: SurveyGroupForm,
        props: { mode: 'edit' }
    }
]
